import React from 'react'

import { MultipleAddressLine } from '@grandvisionhq/forms'
import { useIntl } from '@grandvisionhq/state'

type Props = {
  required?: boolean
  streetComponent?: React.ElementType
  shouldCombineAddress?: boolean
}

export const Address = ({ required = true, streetComponent, shouldCombineAddress }: Props) => {
  const { getLabel } = useIntl()

  return (
    <MultipleAddressLine
      label={getLabel('checkout.address.addressLine')}
      errorMessage={getLabel('checkout.address.addressLine.errorMessage')}
      addLineLabel={getLabel('checkout.address.addressLine.addAddressLine')}
      required={required}
      maxLength={50}
      initialLineAmount={2}
      lineTwoLabel={`${getLabel('checkout.address.addressLineTwo')}`}
      streetComponent={streetComponent}
      shouldCombineAddress={shouldCombineAddress}
    />
  )
}
